export function convertDemoSwatchesToRadioOptions(swatches) {
    var options = [];
    for (let label in swatches) {
        options.push({ value: swatches[label], label: label });
    }
    // Push final option for More colours.
    options.push({ value: "____", label: "More colours", tier: "boost" });
    return options;
}
